<template>
  <div>
    <div class="container">
      <div class="goods_list">

        <div class="goods_list_item" v-for="(categoryCourse,index) in categoryCourseList" :key="index" @click="openDetail(categoryCourse)">
          <!-- 商品图 -->
          <div class="goods_image">
            <img
              :src="categoryCourse.course.image"
              alt=""
              style="width: 100%; vertical-align: middle"
            />
          </div>
          <!-- 名字 -->
          <div class="goods_item_title">
            <span>{{categoryCourse.course.name}}</span>
          </div>
          <!-- 按钮 -->
          <div class="searchButton">
            <span>查看详情</span>
          </div>
        </div>

      </div>
    </div>

    <foot/>

  </div>
</template>
<script>
import CryptoJS from "crypto-js";
const token = '1c3265b23f05b421e78e82e6ea287214'
const encryptToken = CryptoJS.AES.encrypt(
  new Date().getTime().toString(),
  token
).toString();

export default {
    data() {
        return {
          categoryCourseList: null,
        }
    },
    created() {
      document.title = '品谱';
      this.getData()
    },
    watch:{
      $route: {
        handler(newVal, oldVal) {
          //判断newVal有没有值监听路由变化
          if (newVal != oldVal) {
            location.reload()
          }
        },
        deep: true
      }
    },
    methods: {
        openDetail(categoryCourse) {
            this.$router.push('/Tropicalfish?courseId=' + categoryCourse.course.id)
        },
        getData() {
          this.$axios.post("/mini/v1/course/list", {
            categoryId: this.$route.query.categoryId,
            encryptToken
          },{
            header: {
              "content-type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res=>{
            this.categoryCourseList = res.data.data.categoryCourseList
          })
        },
    },
};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  .goods_list {
    display: flex;
    flex-wrap: wrap;
    .goods_list_item {
      width: 360px;
      margin-right: 60px;
      margin-bottom: 60px;
      cursor: pointer;
      &:hover {
        .searchButton {
          background-color: #2e6ab0;
          border: 0;
          &:hover {
            background-color: #3576c0;
          }
          span {
            color: #fff;
          }
        }
      }
      .goods_item_title {
        width: 360px;
        margin: 30px 0;
        font-size: 28px;
        color: #333;
        text-align: center;
        letter-spacing: 1.2px;
        // 字体溢出隐藏
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .searchButton {
        width: 360px;
        height: 60px;
        background-color: #fff;
        text-align: center;
        border: 2px solid #2e6ab0;
        span {
          font-size: 20px;
          color: #2e6ab0;
          line-height: 60px;
        }
      }
    }
  }
  .goods_list .goods_list_item:nth-child(3n) {
    margin-right: 0 !important;
  }
}
</style>